export default "__VITE_ASSET__CRPTa4fS__"